<script setup>
import store from '@/store';

import { computed } from 'vue';

defineOptions({
  name: 'ConnectionState',
});

const total = computed(() => store.state.total);
const connected = computed(() => store.state.connected);
</script>

<template>
  <div class="content connectionState is-size-6-mobile is-size-5-tablet">
    <p>
      totaal aantal mensen in de wachtkamer: <b>{{ total }}</b>
    </p>
  </div>
</template>
<style lang="scss" scoped>
.connectionState {
  border: 1px solid $pinkDark;
  background-color: $pink;
  border-radius: $defaultSize;
  padding: 1 * $defaultSize;
  max-width: 10 * $defaultSize;
}
</style>
